/* ==========================================================================
   Text Image Section - behaviour
   Loaded with `defer`, so DOM is parsed before this runs (no need to
   wait for DOMContentLoaded). The old resize-driven button-position
   logic has been removed: positioning is now handled purely via CSS
   custom properties + a media query (see text-image.css), which is
   cheaper and avoids layout thrashing on resize/scroll.
   ========================================================================== */

(function () {
  var sections = document.querySelectorAll('.section-text-image.devx-add-all-to-cart');

  sections.forEach(function (section) {
    var bannerLink = section.querySelector('.section-image-link');

    if (bannerLink) {
      section.addEventListener('click', function () {
        var url = bannerLink.getAttribute('href');
        if (url) {
          window.location.href = url;
        }
      });
    }
  });

  // Face scan banners (external redirect)
  var faceScanBanners = document.querySelectorAll('.face-scan__hp');

  faceScanBanners.forEach(function (banner) {
    banner.addEventListener('click', function () {
      window.location.href = 'https://main.dqcdds2d7hqx6.amplifyapp.com';
    });
  });

  /* ------------------------------------------------------------------- *
   * NOTE: the markup includes a hidden `.product-desc__addn` block with
   * per-product variant IDs and prices (`.devx-all-products`), and a
   * `.valentine-loader` / `.loading` state on the section. No "add all
   * to cart" cart logic was present in the original script either - if
   * you need that wired up (e.g. POST to /cart/add.js for each variant,
   * toggling the `.loading` class while the request is in flight), let
   * me know and I can add it.
   * ------------------------------------------------------------------- */

  if (window.Shopify && window.Shopify.designMode) {
    // No-op placeholder retained for theme editor compatibility.
    // Add any editor-only listeners here if needed in future.
  }
})();